import { useTenantContext } from '../../auth/useTenantContext';
import { useVoiceConfig, VoiceGatewayUnreachableError } from '../../api/voiceConfig';
import { ProviderStatusCard } from '../../components/voice-config/ProviderStatusCard';
import { CacheTtsCard } from '../../components/voice-config/CacheTtsCard';
import { VoiceGatewayDownBanner } from '../../components/voice-config/VoiceGatewayDownBanner';
import { PageHeading } from '../../layouts/PageHeading';

export default function VoiceConfigPage() {
  const { token } = useTenantContext();
  const { data, error, isLoading } = useVoiceConfig(token);

  if (error instanceof VoiceGatewayUnreachableError) {
    return (
      <div>
        <PageHeading scope="Voice provider" />
        <VoiceGatewayDownBanner detail={error.detail} />
      </div>
    );
  }
  if (isLoading || !data) {
    return (
      <div>
        <PageHeading scope="Voice provider" />
        <p>Caricamento…</p>
      </div>
    );
  }

  return (
    <div>
      <PageHeading scope="Voice provider" />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
        <ProviderStatusCard title="STT primario" data={data.stt.primary} />
        <ProviderStatusCard title="STT fallback" data={data.stt.fallback} />
        <ProviderStatusCard title="TTS primario" data={data.tts.primary} />
        <ProviderStatusCard title="TTS fallback" data={data.tts.fallback} />
      </div>
      <div style={{ marginTop: 16 }}>
        <CacheTtsCard data={data.cache} />
      </div>
      <p style={{ marginTop: 16, color: 'var(--vp-text-2)', fontSize: 'var(--vp-text-sm)' }}>
        Finestra: ultimi {data.window_minutes} minuti · raccolto: {new Date(data.collected_at).toLocaleString('it-IT')}
      </p>
    </div>
  );
}
